var map = {
	"./BINANCE_COIN.png": "293f",
	"./BITCOIN.png": "4b9f",
	"./BITCOIN_CASH.png": "7735",
	"./CLASSIC_ETHEREUM.png": "33e5",
	"./DASH.png": "f606",
	"./DOGE_COIN.png": "8e5e",
	"./EOS.png": "e79d",
	"./ETHEREUM.png": "d653",
	"./LITE_COIN.png": "e91e",
	"./RIPPLE.png": "4a4a",
	"./STELLAR.png": "b122",
	"./TETHER.png": "ac89",
	"./TOMAN.png": "1d21",
	"./TRON.png": "ad55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3183";